import { ReactSVG } from 'react-svg';

import { Header, CloseImg } from '@components/molecules/CardHeader/styles';
import { Overlay } from '@components/organisms/Overlay';

import { SliceColorSample } from '@components/slices/SliceColorSample';

import closeImg from 'images/x.svg';

import * as S from './styles';
import { IProps } from './types';

export const ColorSamples: React.FC<IProps> = ({
  show,
  hide,
  target,
  isMinimalist,
  colorSample,
}: IProps) => (
  <Overlay position="fit" show={show} hide={hide} target={target}>
    <S.Modal>
      <Header divider={false}>
        <CloseImg>
          <ReactSVG src={closeImg} onClick={hide} />
        </CloseImg>
      </Header>
      <S.Content>
        {colorSample.map((z, i) => (
          <SliceColorSample
            slice={z}
            context={{ isMinimalist }}
            key={`colorSample_${i}`}
          />
        ))}
      </S.Content>
    </S.Modal>
  </Overlay>
);
